import React from 'react'
import classnames from 'classnames'
import { camelize } from 'humps'

import Checkmark from 'images/icons/checkmark.svg'
import { TasteProfileIcon } from 'environments/TasteProfileOnboarding/components'

import {
  TASTE_PROFILE_FILTER,
  COUNTRY_FILTER
} from 'constants/filtering'

import styles from './radioFilter.css'
import { closeButton } from '../FilterPanel/filterPanel.css'

const getIdForInput = (input, i = 0) => {
  const id = input.toLowerCase().replace(/ /g, '-')
  return `${id}-${i}`
}

const RadioFilter = (props) => {
  const {filter, onChange} = props
  const isCountryFilter = filter.name === COUNTRY_FILTER.NAME
  const isTasteProfileFilter = filter.name === TASTE_PROFILE_FILTER.NAME

  return filter.options
    // FIXME in GG-9988, filter below can be removed
    .filter(({color}) => {
      return color !== 3
    })
    .map(({value, selected, label}, i) => {
      const disabled = isCountryFilter
        ? selected
        : false
      return (
        <div
          key={value}
          className={styles.wrapper}
        >
          <input
            id={getIdForInput(value, i)}
            className={styles.checkbox}
            type={filter.type}
            checked={selected}
            onChange={() => onChange(filter.name, value, props.tasteProfiles)}
          />
          {/* TODO: Improve A11Y and re-enable ESLint */}
          {/* eslint-disable jsx-a11y/label-has-for */}
          <label
            htmlFor={getIdForInput(value, i)}
            className={classnames(styles.label, {
              [styles.optionLabelEnabled]: !disabled,
              [styles.optionSelectedLabel]: selected
            })}
          >{/* eslint-enable */}
            {selected &&
            <Checkmark className={styles.checkmark} />
            }
            {isTasteProfileFilter &&
            <div className={styles.tasteProfileIconWrapper}>
              <TasteProfileIcon profile={camelize(value)} width={50} />
            </div>
            }
            {label}
            {selected && !isTasteProfileFilter &&
            <span
              key={'close'}
              className={classnames(closeButton, styles.removeFilterButton)}
            >
              X
            </span>
            }
          </label>
        </div>
      )
    })
}

export default RadioFilter
